import React from 'react';
import {
  PayCircleOutlined,
  ShoppingCartOutlined,
  MessageOutlined,
  TeamOutlined,
  UserOutlined,
  DashboardOutlined,
  ApiOutlined,
  CameraOutlined,
  EditOutlined,
  CodeOutlined,
  LineOutlined,
  BarChartOutlined,
  AreaChartOutlined,
  StockOutlined,
  ControlOutlined,
  ApartmentOutlined,
  BulbTwoTone,
  InfoCircleOutlined,
  CaretUpOutlined,
  CaretDownOutlined
} from '@ant-design/icons';

export default {
  'pay-circle-o': <PayCircleOutlined />,
  'shopping-cart': <ShoppingCartOutlined />,
  'camera-o': <CameraOutlined />,
  'line-chart': <LineOutlined />,
  'code-o': <CodeOutlined />,
  'area-chart': <AreaChartOutlined />,
  'bar-chart': <BarChartOutlined />,
  analyze: <StockOutlined />,
  control: <ControlOutlined />,
  apartment: <ApartmentOutlined />,
  team: <TeamOutlined />,
  message: <MessageOutlined />,
  dashboard: <DashboardOutlined />,
  user: <UserOutlined />,
  api: <ApiOutlined />,
  edit: <EditOutlined />,
  bulb: <BulbTwoTone />,
  info: <InfoCircleOutlined />,
  caretup: <CaretUpOutlined />,
  caretdown: <CaretDownOutlined />
};
